import { Grid } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { DateTime } from 'luxon';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import UnreadMessages from '../../components/Dashboard/UnreadMessages/UnreadMessages';
import UnrespondedByChannel from '../../components/Dashboard/UnrespondedByChannel/UnrespondedByChannel';
import PageMain from '../../components/Navigation/PageMain/PageMain';
import useAsyncGetContactMessageChannelStats from '../../hooks/useAsyncGetContactMessageChannelStats';
import {
    ContactMessageChannelStats,
    buildContactMessageChannelRequest,
} from '../../sic-lib/types/ContactMessageChannelStats';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        padding: theme.spacing(2),
        display: 'flex',
        flexFlow: 'row wrap',
        height: '100%',
        minHeight: '100%',
        justifyContent: 'space-evenly',
        backgroundColor: theme.palette.backgroundMainLayout.main,
        overflow: 'auto',
    },
}));

function MainPage() {
    const { classes } = useStyles();

    const { asyncGetContactMessageChannelStats } = useAsyncGetContactMessageChannelStats();

    const [channelDate, setChannelDate] = React.useState<DateTime>(
        DateTime.local().minus({ days: 14 }),
    );

    const [dashboardStats, setDashboardStats] = React.useState<ContactMessageChannelStats>({
        contactStats: {
            new: 0,
            active: 0,
            unassigned: 0,
            unread: 0,
            unresponded: 0,
        },
        channelsStats: [],
        agenda: {
            today: 0,
            weekly: 0,
            monthly: 0,
        },
    });

    const requestStats = async () => {
        const dates = buildContactMessageChannelRequest({
            contactsDate: '',
            channelsDate: channelDate.toLocaleString(),
        });
        const asyncResult = await asyncGetContactMessageChannelStats(dates);
        //console.log('asyncResult', asyncResult);
        if (asyncResult) {
            setDashboardStats(asyncResult);
        }
    };

    React.useEffect(() => {
        requestStats();
    }, [channelDate]);

    // React.useEffect(() => {
    //     console.log('dashboardStats', dashboardStats);
    // }, [dashboardStats]);

    return (
        <PageMain pageTitle="Dashboard" showError={false} showLoading={false}>
            <div className={classes.root}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={6}>
                        <UnrespondedByChannel
                            setChannelDate={setChannelDate}
                            channelStats={dashboardStats.channelsStats}
                            date={channelDate}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <UnreadMessages />
                    </Grid>
                </Grid>
            </div>
            {/* <div className={classes.root}> */}
            {/* <div className={classes.MainTop}>
                    <NewLeads value={dashboardStats.contactStats.new} title='New Leads' />
                    <RecentActivities value={dashboardStats.contactStats.active} title='Recent Activities' />
                    <UnassignedLeads value={dashboardStats.contactStats.unassigned} title='Unassigned Leads' />
                    <UnrespondedMessages value={dashboardStats.contactStats.unresponded} title='Unresponded Messages' />

                </div> */}
            {/* <div className={classes.MainLeft}>
                    <UnrespondedByChannel
                        setChannelDate={setChannelDate}
                        channelStats={dashboardStats.channelsStats}
                        date={channelDate}
                    /> */}
            {/*<div className={classes.leftBottom}>
                        <TodayAgenda eventCounter={dashboardStats.agenda.today} />
                        <WeeklyAgenda eventCounter={dashboardStats.agenda.weekly} />
                    </div>*/}
            {/* </div>
                <div className={classes.MainRight}>
                    <UnreadMessages /> */}
            {/*<div className={classes.rightBottom}>
                        <MonthlyAgenda eventCounter={dashboardStats.agenda.monthly} />
                        <CalendarView />
                    </div>*/}
            {/* </div>
            </div> */}
        </PageMain>
    );
}

export default MainPage;
